import { Helmet } from 'react-helmet-async';

export const GoogleAnalytics = () => {
  const gtmScript = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'AW-17335841863');
  `;

  return (
    <Helmet>
      <script async src="https://www.googletagmanager.com/gtag/js?id=AW-17335841863"></script>
      <script dangerouslySetInnerHTML={{ __html: gtmScript }} />
    </Helmet>
  );
};

export default GoogleAnalytics;
